
'use client';
import type React from 'react';
import { CSSProperties } from "react";
import { Buttons } from '../../../../components/ui/button';
import { Badge } from '../../../../components/ui/badge';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import svgPaths from '../../../../imports/svg-knollny4nu';
import svgQuestComplete from '../../../../imports/svg-f1z862fadf';
import badgeImg from '../../../../../src/assets/img/NewUI_Images/badge.jpeg'
import { useParams } from 'react-router-dom';
import {
  CustomCoinIcon,
  CustomHomeIcon,
  CustomMapIcon,
  CustomMedalIcon,
  CustomRankingIcon,
  CustomSettingsIcon,
} from '../../../../components/ui/CustomIcons';
import imgBackground from '../../../../assets/img/NewUI_Images/background.png';
import { useColor } from '../../../../components/ui/ColorContext';
import ColorPicker from '../../../../components/ui/ColorPicker';
import { Slider } from '../../../../components/ui/slider';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '../../../../components/ui/dialog';

import { background, Box, Img, Text } from '@chakra-ui/react';
import { startTransition, useContext, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ScoreContext } from '../GamePreview';
import BtnClickSound from "../../../../assets/adiuo/simple-btn-click.mp3";
// Helper function to convert hex to RGB
const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return "0, 255, 187"; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};


const normalizeStarValue = (value: number): number => {
  const clamped = Math.max(0, Math.min(1, Number(value) || 0));
  if (clamped >= 0.999) return 1;
  if (clamped <= 0.001) return 0;
  return clamped;
};

const NavigationArrow: React.FC<{
  direction: 'left' | 'right';
  onClick: () => void;
}> = ({ direction, onClick }) => {
  const { primaryColor } = useColor();
  return (
    <Buttons
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="h-10 w-[3.75rem] rounded-3xl px-4 py-2 transition-all duration-200 hover:scale-110"
      style={{
        background: `linear-gradient(${
          direction === 'left' ? '275.041deg' : '90deg'
        },
                rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(
          primaryColor,
        )}, 0.15) 84.803%)`,
        border: `1px solid ${primaryColor}`,
        boxShadow: `0px 0px 15.9542px 0px rgba(${hexToRgb(primaryColor)}, 0.3)`,
      }}
    >
      {direction === 'left' ? (
        <ChevronLeft className="!h-4 !w-4 text-white" />
      ) : (
        <ChevronRight className="!h-4 !w-4 text-white" />
      )}
    </Buttons>
  );
};

// Floating particles components
  const FloatingParticles1: React.FC = () => {
    const particles = [
      { left: "calc(20% + 7.937rem)", top: "9.584rem" },
      { left: "calc(20% + 14.317rem)", top: "15.666rem" },
      { left: "calc(60% + 9.806rem)", top: "11.972rem" },
      { left: "calc(60% + 10.702rem)", top: "5.629rem" },
      { left: "calc(60% + 13.687rem)", top: "14.397rem" },
      { left: "calc(20% + 7.750rem)", top: "20.815rem" },
      { left: "calc(40% + 1.279rem)", top: "5.443rem" },
      { left: "calc(40% + 1.652rem)", top: "14.584rem" },
      { left: "calc(60% + 3.352rem)", top: "5.070rem" },
      { left: "calc(60% + 5.068rem)", top: "15.666rem" },
      { left: "calc(20% + 8.310rem)", top: "4.697rem" },
      { left: "calc(20% + 14.951rem)", top: "12.047rem" },
      { left: "calc(60% + 4.695rem)", top: "12.979rem" },
      { left: "calc(60% + 15.925rem)", top: "8.651rem" },
      { left: "calc(60% + 6.561rem)", top: "10.517rem" },
      { left: "calc(20% + 17.078rem)", top: "15.666rem" },
      { left: "calc(20% + 8.869rem)", top: "16.449rem" },
      { left: "calc(60% + 14.060rem)", top: "21.188rem" },
      { left: "calc(60% + 8.463rem)", top: "14.994rem" },
    ];

    return (
      <>
        {particles.map((particle, index) => (
          <div
            key={index}
            className="absolute bg-[rgba(255,255,255,0.4)] rounded-[3.75rem] size-[1.194px] animate-pulse transition-all duration-300"
            style={{
              left: particle.left,
              top: particle.top,
            }}
          />
        ))}
      </>
    );
  };

  const FloatingParticles2: React.FC = () => {
    const particles = [
      { left: "calc(20% + 4.607rem)", top: "16.449rem" },
      { left: "calc(20% + 11.077rem)", top: "30.974rem" },
      { left: "calc(60% + 7.011rem)", top: "22.152rem" },
      { left: "calc(60% + 7.919rem)", top: "7.003rem" },
      { left: "calc(60% + 10.946rem)", top: "27.944rem" },
      { left: "calc(20% + 4.438rem)", top: "43.271rem" },
      { left: "calc(20% + 16.109rem)", top: "6.558rem" },
      { left: "calc(20% + 16.487rem)", top: "28.390rem" },
      { left: "calc(60% + 0.465rem)", top: "5.667rem" },
      { left: "calc(60% + 2.206rem)", top: "30.974rem" },
      { left: "calc(20% + 4.985rem)", top: "4.745rem" },
      { left: "calc(20% + 11.720rem)", top: "22.330rem" },
      { left: "calc(60% + 1.828rem)", top: "24.558rem" },
      { left: "calc(60% + 13.196rem)", top: "14.221rem" },
      { left: "calc(60% + 3.719rem)", top: "18.677rem" },
      { left: "calc(20% + 13.877rem)", top: "30.974rem" },
      { left: "calc(20% + 5.552rem)", top: "32.845rem" },
      { left: "calc(60% + 11.325rem)", top: "44.193rem" },
      { left: "calc(60% + 5.649rem)", top: "29.370rem" },
    ];

    return (
      <>
        {particles.map((particle, index) => (
          <div
            key={index}
            className="absolute bg-[rgba(255,255,255,0.6)] rounded-[3.332rem] size-[1.858px] animate-pulse transition-all duration-300"
            style={{
              left: particle.left,
              top: particle.top,
            }}
          />
        ))}
      </>
    );
  };

  const FloatingParticles3: React.FC = () => {
    const particles = [
      { left: "calc(20% + 4.374rem)", top: "30.638rem" },
      { left: "calc(20% + 10.754rem)", top: "36.719rem" },
      { left: "calc(60% + 6.244rem)", top: "33.026rem" },
      { left: "calc(60% + 7.139rem)", top: "26.683rem" },
      { left: "calc(60% + 10.124rem)", top: "35.451rem" },
      { left: "calc(20% + 4.188rem)", top: "41.868rem" },
      { left: "calc(20% + 15.716rem)", top: "26.496rem" },
      { left: "calc(20% + 16.090rem)", top: "35.637rem" },
      { left: "calc(60% - 0.211rem)", top: "26.123rem" },
      { left: "calc(60% + 1.506rem)", top: "36.719rem" },
      { left: "calc(20% + 4.747rem)", top: "25.750rem" },
      { left: "calc(20% + 11.388rem)", top: "33.100rem" },
      { left: "calc(60% + 1.133rem)", top: "34.033rem" },
      { left: "calc(60% + 12.363rem)", top: "29.705rem" },
      { left: "calc(60% + 2.998rem)", top: "31.570rem" },
      { left: "calc(20% + 13.515rem)", top: "36.719rem" },
      { left: "calc(20% + 5.307rem)", top: "37.503rem" },
      { left: "calc(60% + 10.497rem)", top: "42.241rem" },
      { left: "calc(60% + 4.901rem)", top: "36.048rem" },
    ];

    return (
      <>
        {particles.map((particle, index) => (
          <div
            key={index}
            className="absolute  bg-[rgba(255,255,255,0.5)] rounded-[3.731rem] size-[1.194px] animate-pulse transition-all duration-300"
            style={{
              left: particle.left,
              top: particle.top,
            }}
          />
        ))}
      </>
    );
  };

  const getRating = (stars: number): string => {
  switch(stars) {
    case 1: return 'DEVELOPING';
    case 2: return 'STRONG';
    case 3: return 'EXCELLENT';
    default: return '';
  }
};

interface StarsCardProps {
  filledStars: number[]; // [1, 0.35, 0]
  totalStars: number;
  visible?: boolean;
  animationDelay?: number;
  onStarIgnite?: () => void;
}

interface StarProps {
  isLit: boolean;
  fillPercentage: number; // 0 → 1
  index: number;
  shouldAnimate: boolean;
  pulseComplete: boolean;
  primaryColor: string;
}

const Star = ({
  isLit,
  fillPercentage,
  index,
  shouldAnimate,
  pulseComplete,
  primaryColor,
}: StarProps) => (
  <div
    className="aura-wrapper relative w-12 h-12"
    style={{ animationDelay: `${index * 300}ms` }}
  >
    {/* Pulse ring */}
    {isLit && shouldAnimate && !pulseComplete && (
      <div className="pulse-ring absolute left-1/2 top-1/2" />
    )}

    <div
      className={`starburst ${isLit ? 'filled' : 'empty'} ${
        isLit && shouldAnimate ? 'star-pop' : ''
      }`}
    >
      <svg viewBox="0 0 24 24" className="w-full h-full">
        <defs>
          {/* Base gradient */}
          <linearGradient
            id={`plasmaGrad-${index}`}
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor={`rgba(${hexToRgb(primaryColor)}, 1)`} />
            <stop offset="50%" stopColor={`rgba(${hexToRgb(primaryColor)}, 0.8)`} />
            <stop offset="100%" stopColor={`rgba(${hexToRgb(primaryColor)}, 0.6)`} />
          </linearGradient>

          {/* PARTIAL FILL MASK */}
          <linearGradient id={`fillMask-${index}`}>
            <stop offset={`${fillPercentage * 100}%`} stopColor="white" />
            <stop offset={`${fillPercentage * 100}%`} stopColor="black" />
          </linearGradient>

          <mask id={`starMask-${index}`}>
            <rect width="24" height="24" fill={`url(#fillMask-${index})`} />
          </mask>
        </defs>

        {isLit ? (
          <g className="star-fill">
            <polygon
              points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9"
              fill={`url(#plasmaGrad-${index})`}
              mask={`url(#starMask-${index})`}
              stroke={`rgba(${hexToRgb(primaryColor)}, 1)`}
              strokeWidth="1.2"
            />
            <circle cx="12" cy="12" r="2.4" fill="rgba(255,255,255,0.95)" />
          </g>
        ) : (
          <g className="star-empty">
            <polygon
              points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9"
              fill="transparent"
              stroke={`rgba(${hexToRgb(primaryColor)}, 0.4)`}
              strokeWidth="1"
            />
          </g>
        )}
      </svg>
    </div>

    {/* Aura ring */}
    {isLit && (
      <svg
        className="absolute pointer-events-none"
        style={{
          top: '-6px',
          left: '-6px',
          width: 'calc(100% + 12px)',
          height: 'calc(100% + 12px)',
        }}
        viewBox="0 0 40 40"
      >
        <circle
          cx="20"
          cy="20"
          r="17"
          fill="none"
          stroke={`rgba(${hexToRgb(primaryColor)}, 0.9)`}
          strokeWidth="1.2"
          strokeDasharray="8 12"
          strokeDashoffset="6"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 20 20"
            to="360 20 20"
            dur="4s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    )}
  </div>
);

export const StarsCard = ({
  filledStars,
  totalStars,
  visible = true,
  animationDelay = 0,
  onStarIgnite,
}: StarsCardProps) => {
  const [litStars, setLitStars] = useState(0);
  const [showRating, setShowRating] = useState(false);
  const [animatedStars, setAnimatedStars] = useState<Set<number>>(new Set());
  const [completedPulseAnimations, setCompletedPulseAnimations] =
    useState<Set<number>>(new Set());


  const filledStarsKey = filledStars.join('|');

useEffect(() => {
  if (!visible) return;

  setLitStars(0);
  setShowRating(false);
  setAnimatedStars(new Set());
  setCompletedPulseAnimations(new Set());

  const timeouts: number[] = [];

  filledStars.forEach((fill, i) => {
    if (fill === 1) {
      timeouts.push(
        window.setTimeout(() => {
          setLitStars(prev => Math.max(prev, i + 1));
          setAnimatedStars(prev => new Set(prev).add(i));
          onStarIgnite?.();
        }, animationDelay + i * 400),
      );

      timeouts.push(
        window.setTimeout(() => {
          setCompletedPulseAnimations(prev => new Set(prev).add(i));
        }, animationDelay + i * 400 + 700),
      );
    }
  });

  timeouts.push(
    window.setTimeout(() => {
      setShowRating(true);
    }, animationDelay + filledStars.length * 400 + 200),
  );

  return () => timeouts.forEach(clearTimeout);
}, [visible, filledStarsKey, animationDelay]);


  const rating = getRating(filledStars.filter(v => v === 1).length);
  const { primaryColor } = useColor();

  return (
    
        <div
      className="relative shrink-0 grow basis-0 rounded-[1.402rem] backdrop-blur-[2.188rem] backdrop-filter 2xl:aspect-square"
      style={{
        background: `linear-gradient(21deg, rgba(0, 0, 0, 0.40) -10.76%, rgba(${hexToRgb(
          primaryColor,
        )}, 0.2) 127.18%)`,
      }}
    >
      <div className="flex flex-row items-center overflow-clip relative md2x:size-full">
        <div className="relative box-border flex h-[18rem] w-[18rem] flex-row content-stretch items-center justify-start gap-[0.569rem] p-4">
          <div
            className="[background-size:auto,_cover] basis-0 bg-[position:0%_0%,_50%_50%] grow relative rounded-[0.876rem] shrink-0 flex flex-col items-center justify-center gap-3 h-full max-md2x:p-3"
            style={{
              backgroundImage:
                "linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 97.457%), url('https://plus.unsplash.com/premium_photo-1673795753337-2f32418f12fb?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
            }}
          >
          <span className="text-white font-rubik font-bold text-xl">Stars</span>

          <div className="flex gap-5">
            {Array.from({ length: totalStars }).map((_, i) => (
              <Star
                key={i}
                isLit={filledStars[i] > 0}
                fillPercentage={filledStars[i] ?? 0}
                index={i}
                shouldAnimate={animatedStars.has(i)}
                pulseComplete={completedPulseAnimations.has(i)}
                primaryColor={primaryColor}
              />
            ))}
          </div>

          <span
            className={`text-[9px] font-orbitron tracking-[0.25em] transition-all duration-500 ${
              showRating ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
            }`}
            style={{ color: primaryColor }}
          >
            {rating}
          </span>
        </div>
      </div>
    </div>
    </div>
  );
};

const RewardCard: React.FC<{
  title: string;
  progress?: number;
  maxProgress?: number;
    badgeImg?: string;
  icon: 'points' | 'trophy';
  allQuestScores?: {  
    totalQuestScore:number;
    replayAllowedTotalScore: number;
    totalScore: number;
    totalQuest?: number;
    replayAllowedScoreSumFromObject?: number;
  };
}> = ({ title, progress, maxProgress, icon, allQuestScores }) => {
  const { primaryColor } = useColor();

  
  return (
    <div
      className="relative shrink-0 grow basis-0 rounded-[1.402rem] backdrop-blur-[2.188rem] backdrop-filter 2xl:aspect-square"
      style={{
        background: `linear-gradient(21deg, rgba(0, 0, 0, 0.40) -10.76%, rgba(${hexToRgb(
          primaryColor,
        )}, 0.2) 127.18%)`,
      }}
    >
      <div className="flex flex-row items-center overflow-clip relative md2x:size-full">
        <div className="relative box-border flex h-[18rem] w-[18rem] flex-row content-stretch items-center justify-start gap-[0.569rem] p-4">
          <div
            className="[background-size:auto,_cover] basis-0 bg-[position:0%_0%,_50%_50%] grow relative rounded-[0.876rem] shrink-0 flex flex-col items-center justify-center gap-3 h-full max-md2x:p-3"
            style={{
              backgroundImage:
                "linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 97.457%), url('https://plus.unsplash.com/premium_photo-1673795753337-2f32418f12fb?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
            }}
          >
            {/* Title */}
            <div className="[text-shadow:rgba(0,0,0,0.46)_0px_6.762px_16.427px] flex flex-col font-rubik font-bold justify-center leading-[0] relative shrink-0 text-[#ffffff] text-xl text-center text-nowrap tracking-[0.0057px]">
              <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
                {title}
              </p>
            </div>

            {/* Icon and Value */}
            {icon === "points" && allQuestScores && (
                <div className="flex flex-col items-center">
                  <Buttons
                    variant="ghost"
                    size="sm"
                    className="w-11 h-11 !px-0 py-0 relative rounded-xl -mb-1.5 cursor-default"
                    style={{
                      boxShadow: "0px 0px 23.386px 0px rgba(0, 0, 0, 0.50)",
                      background: `linear-gradient(151.477deg, rgba(${hexToRgb(
                        primaryColor
                      )}, 0.3), rgb(0, 0, 0))`,
                    }}
                  >
                    <div
                      className="absolute top-[1px] left-[1px] right-[1px] bottom-[1px] rounded-xl flex items-center justify-center"
                      style={{
                        background: `linear-gradient(151.477deg, rgb(0, 0, 0) 17.606%, rgba(${hexToRgb(
                          primaryColor
                        )}, 0.5) 188.68%)`,
                        zIndex: 1,
                      }}
                    >
                      <CustomCoinIcon
                        color={primaryColor}
                        className="!size-12"
                      />
                    </div>
                  </Buttons>
                  <Badge
                    variant="secondary"
                    className="h-12 px-4 flex items-center -ml-1.5 rounded-2xl min-w-36 font-rubik"
                    style={{
                      background: `linear-gradient(170.484deg, rgb(0, 0, 0) 17.606%, rgba(${hexToRgb(
                        primaryColor
                      )}, 0.5) 188.68%)`,
                      border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.3)`,
                      boxShadow: "0px 0px 23.3864px 0px rgba(0,0,0,0.5)",
                    }}
                  >
                    <div className="text-white font-medium text-xl tracking-[0.0125rem]">
                      {/* ✅ SHOW OVERALL GAME SCORES */}
                      {allQuestScores.totalQuestScore}/{allQuestScores.totalScore}
                    </div>
                  </Badge>
                </div>
            )}

            {icon === 'trophy' && (
              <div>
                  <Buttons
                    variant="ghost"
                    size="sm"
                    className=" w-28 h-28 !px-0 py-0 relative rounded-3xl  cursor-default"
                    style={{
                      boxShadow: "0px 0px 23.386px 0px rgba(0, 0, 0, 0.50)",
                      background: `linear-gradient(151.477deg, rgba(${hexToRgb(
                        primaryColor
                      )}, 0.3), rgb(0, 0, 0))`,
                    }}
                  >
                    <div
                      className="absolute top-[1px] left-[1px] right-[1px] bottom-[1px] rounded-3xl flex items-center justify-center"
                      style={{
                        background: `linear-gradient(151.477deg, rgb(0, 0, 0) 17.606%, rgba(${hexToRgb(
                          primaryColor
                        )}, 0.5) 188.68%)`,
                        zIndex: 1,
                      }}
                    >
                      {/* <CustomMedalIcon
                        color={primaryColor}
                        className="!size-28 !size-16"
                      /> */}
                         <img src={badgeImg} alt="badge" className="w-18 h-18 object-contain" />
                    </div>
                  </Buttons>
                </div>
            )}
          </div>
        </div>
      </div>
      <div
        className="absolute border inset-0 pointer-events-none rounded-[1.402rem]"
        style={{
          borderColor: `rgba(${hexToRgb(primaryColor)}, 0.2)`,
          boxShadow: `0px 3.58px 19.689px 0px rgba(${hexToRgb(
            primaryColor,
          )}, 0.2)`,
        }}
      />
    </div>
  );
};

const OverallQuestCompletionFutureTheme: React.FC<{
  onNavigate?: (direction: 'left' | 'right') => void;
  setIsCompletedVideoMap: any;
  completedVideoRef: any;
  iscompletedVideoMap: any;
  formData: any;
  imageSrc: any;
  questState: any;
  setType: any;
  setData: any;
  setQuestState: any;
  type: any;
  getFeedbackData: any;
  setCurrentScreenId?: any;
  currentScreenId: any;
  getData?: any;
  gameInfo: any;
  data?: any;
  setFeedbackNavigateNext: any;
  currentQuestNo: any;
  preloadedAssets: any;
  setOptions: any;
  profileData: any;
  feedbackList: any;
  setFeedbackList: any;
  learnerPlayList: any;
  setLearnerPlayingDetails: any;
  setprevBlock: any;
  prevBlock: any;
  demoBlocks: any;
  checkCompletionBadge: any;
  handleQuestScore: any;
  allQuestScores: any;
}> = ({
  allQuestScores,
  handleQuestScore,
  iscompletedVideoMap,
  completedVideoRef,
  setIsCompletedVideoMap,
  onNavigate,
  formData,
  imageSrc,
  currentScreenId,
  setCurrentScreenId,
  gameInfo,
  setType,
  setData,
  type,
  questState,
  setQuestState,
  setFeedbackNavigateNext,
  getData,
  data,
  getFeedbackData,
  currentQuestNo,
  preloadedAssets,
  setOptions,
  profileData,
  setFeedbackList,
  feedbackList,
  learnerPlayList,
  setLearnerPlayingDetails,
  setprevBlock,
  prevBlock,
  demoBlocks,
  checkCompletionBadge,
}) => {

  
  const playClickSound = () => {
    try {
      const audio = new Audio(BtnClickSound as string);
      audio.volume = 1;
      audio.play().catch(() => { });

      setTimeout(() => {
        audio.pause();
        audio.currentTime = 0;
      }, 1000);
    } catch (e) {
      // ignore audio errors
    }
  };

  const { primaryColor } = useColor();
  const { profile, setProfile } = useContext(ScoreContext);

  const [curretQuestOptions, setCurrentQuestOptions] = useState(
    gameInfo?.gameQuest?.find(
      (quest: any) => quest?.gameQuestNo == profile?.currentQuest,
    ),
  );
  const finalProfileScore =
    Object.entries(profile?.playerGrandTotal?.questScores).length > 0
      ? profile?.playerGrandTotal?.questScores[
          parseInt(profile.currentQuest)
        ] !== null
        ? profile?.playerGrandTotal?.questScores[parseInt(profile.currentQuest)]
        : curretQuestOptions?.gameMinScore
        ? curretQuestOptions?.gameMinScore
        : 0
      : curretQuestOptions?.gameMinScore
      ? curretQuestOptions?.gameMinScore
      : 0;

  const [geFinalscorequest, SetFinalscore] = useState(finalProfileScore);
  const [quetCompletionMessage, setQuestCompletionMessage] =
    useState<string>('');
  const [QuestTitleLanguage, setQuestTitleLanguage] = useState(null);
  const findQuestCompletionMessage = () => {
    const playerCurrentQuestGrandTotal =
      profile.playerGrandTotal.questScores[parseInt(currentQuestNo)] ?? 0;
    let completionScreenMessage = '';
    const getCompletionQuest = currentQuestNo - 1;

    const currentQuesTGameData = gameInfo?.gameQuest[getCompletionQuest];
    const isSingleMessage =
      currentQuesTGameData?.gameIsSetCongratsSingleMessage === 'true';
    const isScoreWiseMessage =
      currentQuesTGameData?.gameIsSetCongratsScoreWiseMessage === 'true';

    if (isSingleMessage) {
      const questContentFiltered = profileData?.Audiogetlanguage.filter(
        (key: any) => key?.textId === parseInt(currentQuestNo),
      );

      const congratsMsgFiltered = questContentFiltered?.filter(
        (key: any) => key?.fieldName === 'gameCompletedCongratsMessage',
      );

      completionScreenMessage = congratsMsgFiltered?.[0]?.content
        ? congratsMsgFiltered[0]?.content
        : currentQuesTGameData?.gameCompletedCongratsMessage;
    } else if (isScoreWiseMessage) {
      if (
        playerCurrentQuestGrandTotal >
        currentQuesTGameData?.gameDistinctionScore
      ) {
        if (currentQuesTGameData?.gameIsSetDistinctionScore === 'true') {
          completionScreenMessage =
            currentQuesTGameData?.gameAboveDistinctionScoreCongratsMessage;
        } else {
          if (
            playerCurrentQuestGrandTotal > currentQuesTGameData?.gameMinScore
          ) {
            completionScreenMessage =
              currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
          }
        }
      } else if (
        playerCurrentQuestGrandTotal ===
        currentQuesTGameData?.gameDistinctionScore
      ) {
        if (currentQuesTGameData?.gameIsSetDistinctionScore === 'true') {
          completionScreenMessage =
            currentQuesTGameData?.gameAboveDistinctionScoreCongratsMessage;
        } else {
          if (
            playerCurrentQuestGrandTotal > currentQuesTGameData?.gameMinScore
          ) {
            completionScreenMessage =
              currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
          }
        }
      } else if (
        playerCurrentQuestGrandTotal > currentQuesTGameData?.gameMinScore
      ) {
        completionScreenMessage =
          currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
      } else if (
        playerCurrentQuestGrandTotal === currentQuesTGameData?.gameMinScore
      ) {
        completionScreenMessage =
          currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
      } else if (
        playerCurrentQuestGrandTotal < currentQuesTGameData?.gameMinScore
      ) {
        if (currentQuesTGameData?.gameIsSetMinPassScore === 'true') {
          completionScreenMessage =
            currentQuesTGameData?.gameMinimumScoreCongratsMessage;
        } else {
          if (
            playerCurrentQuestGrandTotal <
            currentQuesTGameData?.gameDistinctionScore
          )
            completionScreenMessage =
              currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
        }
      }
    } else if (
      !isSingleMessage &&
      !isScoreWiseMessage &&
      !currentQuesTGameData?.gameIsSetDistinctionScore &&
      !currentQuesTGameData?.gameIsSetMinPassScore
    ) {
      const questContentFiltered = profileData?.Audiogetlanguage.filter(
        (key: any) => key?.textId === parseInt(currentQuestNo),
      );

      const congratsMsgFiltered = questContentFiltered?.filter(
        (key: any) => key?.fieldName === 'gameCompletedCongratsMessage',
      );

      completionScreenMessage = congratsMsgFiltered?.[0]?.content
        ? congratsMsgFiltered[0]?.content
        : currentQuesTGameData?.gameCompletedCongratsMessage;
    } else {
      const questContentFiltered = profileData?.Audiogetlanguage.filter(
        (key: any) => key?.textId === parseInt(currentQuestNo),
      );
      const congratsMsgFiltered = questContentFiltered?.filter(
        (key: any) => key?.fieldName === 'gameCompletedCongratsMessage',
      );

      completionScreenMessage = congratsMsgFiltered?.[0]?.content
        ? congratsMsgFiltered[0]?.content
        : currentQuesTGameData?.gameCompletedCongratsMessage;
    }

    setQuestCompletionMessage(completionScreenMessage);
  };

  useEffect(() => {
    const findCurrentQuest =
      currentQuestNo === parseInt(profile?.currentQuest)
        ? parseInt(profile?.currentQuest)
        : currentQuestNo;
    const QuestContentFiltered = profileData?.Audiogetlanguage.filter(
      (key: any) => key?.textId === findCurrentQuest,
    );
    if (QuestContentFiltered.length > 0) {
      const gameTitleFiltered = QuestContentFiltered.filter(
        (key: any) => key?.fieldName === 'gameScreenTitle',
      );

      const FilteredTitlecontent = gameTitleFiltered[0]?.content
        ? gameTitleFiltered[0]?.content
        : curretQuestOptions?.gameScreenTitle;
      const screenTitleLanguage = FilteredTitlecontent;

      setQuestTitleLanguage(screenTitleLanguage);
    } else {
      setQuestTitleLanguage(curretQuestOptions?.gameScreenTitle);
    }

    findQuestCompletionMessage();
    // checkCompletionBadge();
    // getData();
  }, []);

  useEffect(() => {
    if (gameInfo?.gameQuest.length > 0) {
      const currentQuestData = gameInfo?.gameQuest?.find(
        (quest: any) => quest.gameQuestNo == profile?.currentQuest,
      );
      setCurrentQuestOptions(currentQuestData);
      findQuestCompletionMessage();
    }
  }, [gameInfo?.gameQuest]);

  const previousNavigation = () => {
     playClickSound();
    const questNo = profile?.currentQuest;
    const lastSeq = learnerPlayList?.Prevquestseq[questNo];
    let updateNavigateSeq: any = [...learnerPlayList?.Prevquestseq[questNo]];

    updateNavigateSeq.pop();
    setLearnerPlayingDetails((prev: any) => ({
      ...prev,
      Prevquestseq: { ...prev.Prevquestseq, [questNo]: updateNavigateSeq },
    }));

    let prev =
      prevBlock.length > 0
        ? prevBlock[prevBlock.length - 1]
        : lastSeq
        ? lastSeq[lastSeq.length - 1]
        : null;

    let getBlocks: any;
    if (prev) {
      getBlocks = Object.values(demoBlocks[questNo]).filter(
        (item: any) => item?.blockPrimarySequence === prev,
      );
      if (prevBlock.length === 0 && updateNavigateSeq.length > 0) {
        setprevBlock(updateNavigateSeq);
      }
      prevBlock.pop();
      startTransition(() => {
        setData(getBlocks[0]);
        setType(getBlocks[0]?.blockChoosen);
        if (getBlocks[0]?.blockChoosen === 'Interaction') {
          const optionsFiltered = [];
          const primarySequence = getBlocks[0].blockPrimarySequence;

          for (const option of gameInfo.questOptions) {
            if (profileData?.Audiogetlanguage.length > 0) {
              if (option?.qpSequence === primarySequence) {
                const profilesetlan = profileData?.Audiogetlanguage.find(
                  (key: any) => key?.textId === option.qpOptionId,
                );

                if (profilesetlan) {
                  const languagecont = {
                    ...option,
                    qpOptionText: profilesetlan.content,
                  };
                  optionsFiltered.push(languagecont);
                } else {
                  optionsFiltered.push(option);
                }
              }
            } else {
              if (option?.qpSequence === primarySequence) {
                optionsFiltered.push(option);
              }
            }
          }
          if (gameInfo?.gameData?.gameShuffle === 'true') {
            for (let i = optionsFiltered.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [optionsFiltered[i], optionsFiltered[j]] = [
                optionsFiltered[j],
                optionsFiltered[i],
              ];
            }
          }
          setOptions(optionsFiltered);
        }
        if (questState && questState[profile?.currentQuest]) {
          if (questState[profile?.currentQuest] !== 'Started') {
            setProfile((prev: any) => ({
              ...prev,
              replayScore: profile.score,
            }));
          }
        }

        setCurrentScreenId(13);
      });
      return false;
    } else {
      startTransition(() => {
        setCurrentScreenId(13);
      });
    }
  };
  
  useEffect(() => {
    gameInfo?.gameQuest.map((item: any) => {
      const questNoAsString = item.gameQuestNo.toString();
      if (profile?.completedLevels?.includes(questNoAsString)) {
        const scores = profile?.score;
        if (scores !== undefined) {
          const sums: any = {};
          scores.forEach((score: any) => {
            const quest = score.quest;
            if (!sums[quest]) {
              sums[quest] = 0;
            }
            sums[quest] += score.score;
          });
          const getFinalscores = Object.entries(sums).map(([quest, score]) => ({
            quest,
            score,
          }));
          const getscores = getFinalscores.find(
            (row: any) => row.quest == item.gameQuestNo,
          );
          const finalscore = getscores?.score ?? 0;
          if (gameInfo?.gameData?.gameDisableOptionalReplays === 'false') {
            if (item?.gameIsSetMinPassScore === 'true') {
              const getminpassscore = item?.gameMinScore;

              if (
                finalscore >= getminpassscore &&
                finalscore < item?.gameTotalScore &&
                profile.compQuest.includes(questNoAsString)
              ) {
                setQuestState((prevquestdataList: any) => ({
                  ...prevquestdataList,
                  [item.gameQuestNo]: 'replayallowed',
                }));
              } else {
                if (
                  finalscore !== undefined &&
                  profile.compQuest.includes(questNoAsString)
                ) {
                  const status =
                    gameInfo?.gameData?.gameDisableOptionalReplays === 'false'
                      ? 'replayallowed'
                      : 'completed';

                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'replayallowed',
                  }));
                } else {
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'Started',
                  }));
                }
              }
            } else {
              if (
                finalscore !== undefined &&
                profile.compQuest.includes(questNoAsString)
              ) {
                setQuestState((prevquestdataList: any) => ({
                  ...prevquestdataList,
                  [item.gameQuestNo]: 'replayallowed',
                }));
              } else {
                if (
                  item.gameIsSetMinPassScore === 'false' &&
                  profile.compQuest.includes(questNoAsString)
                ) {
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'completed',
                  }));
                } else {
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'Started',
                  }));
                }
              }
            }
          } else {
            if (
              finalscore !== undefined &&
              profile.compQuest.includes(questNoAsString)
            ) {
              setQuestState((prevquestdataList: any) => ({
                ...prevquestdataList,
                [item.gameQuestNo]: 'completed',
              }));
            } else if (
              item.gameIsSetMinPassScore === 'false' &&
              profile.compQuest.includes(questNoAsString)
            ) {
              setQuestState((prevquestdataList: any) => ({
                ...prevquestdataList,
                [item.gameQuestNo]: 'completed',
              }));
            } else {
              setQuestState((prevquestdataList: any) => ({
                ...prevquestdataList,
                [item.gameQuestNo]: 'Started',
              }));
            }
          }
        }
      } else {
        setQuestState((prevquestdataList: any) => ({
          ...prevquestdataList,
          [item.gameQuestNo]: 'locked',
        }));
      }
    });
  }, [profile?.compleLevel]);
  
  // ✅ NEW STAR LOGIC BASED ON OVERALL GAME SCORES
  const totalGameScore = allQuestScores?.totalScore || 0;
  const userTotalScore = allQuestScores?.totalQuestScore || 0;

const competencyPercentage = totalGameScore > 0
  ? Math.min(
      Math.round((userTotalScore / totalGameScore) * 100),
      100
    )
  : 0;

    let starFill = [0, 0, 0];

  const completionPercentage = totalGameScore > 0 
    ? (userTotalScore / totalGameScore) 
    : 0;

  if (completionPercentage > 0) {
    const scaledScore = completionPercentage * 3;

    starFill[0] = normalizeStarValue(scaledScore);
    starFill[1] = normalizeStarValue(scaledScore - 1);
    starFill[2] = normalizeStarValue(scaledScore - 2);
  }
  

  return (
    <div
      className="relative w-full h-screen overflow-hidden bg-no-repeat bg-center bg-cover bg-black"
      style={{ backgroundImage: `url('${imgBackground}')` }}
    >
      {/* Large glowing gradient backgrounds */}
      <div
        className="absolute h-[44.875rem] top-[-4.188rem] translate-x-[-50%] w-[40.75rem]"
        style={{ left: "calc(50% - 26px)" }}
      >
        <div className="absolute bottom-[-13.928%] left-[-15.337%] right-[-15.337%] top-[-13.928%]">
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 852 918"
          >
            <g filter={`url(#filter0_f_${primaryColor.replace("#", "")})`}>
              <path
                d={svgQuestComplete.p17d92c00}
                fill={`url(#paint0_linear_${primaryColor.replace("#", "")})`}
                fillOpacity="0.3"
              />
            </g>
            <defs>
              <filter
                colorInterpolationFilters="sRGB"
                filterUnits="userSpaceOnUse"
                height="918"
                id={`filter0_f_${primaryColor.replace("#", "")}`}
                width="852"
                x="0"
                y="0"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  mode="normal"
                  result="shape"
                />
                <feGaussianBlur
                  result="effect1_foregroundBlur"
                  stdDeviation="50"
                />
              </filter>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id={`paint0_linear_${primaryColor.replace("#", "")}`}
                x1="413.5"
                x2="413.5"
                y1="100"
                y2="919.949"
              >
                <stop stopColor={primaryColor} />
                <stop offset="1" stopColor={primaryColor} stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>

      {/* Additional glowing backgrounds with rotations */}
      <div
        className="absolute flex h-[55.223rem] items-center justify-center top-[-11.938rem] translate-x-[-50%] w-[52.564rem]"
        style={{ left: "calc(70% - 124.488px)" }}
      >
        <div className="flex-none rotate-[17.888deg]">
          <div className="h-[44.875rem] relative w-[40.75rem]">
            <div className="absolute bottom-[-13.928%] left-[-15.337%] right-[-15.337%] top-[-13.928%]">
              <svg
                className="block size-full"
                fill="none"
                preserveAspectRatio="none"
                viewBox="0 0 852 918"
              >
                <g filter={`url(#filter1_f_${primaryColor.replace("#", "")})`}>
                  <path
                    d={svgQuestComplete.p17d92c00}
                    fill={`url(#paint1_linear_${primaryColor.replace(
                      "#",
                      ""
                    )})`}
                    fillOpacity="0.15"
                  />
                </g>
                <defs>
                  <filter
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                    height="918"
                    id={`filter1_f_${primaryColor.replace("#", "")}`}
                    width="852"
                    x="0"
                    y="0"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      mode="normal"
                      result="shape"
                    />
                    <feGaussianBlur
                      result="effect1_foregroundBlur"
                      stdDeviation="50"
                    />
                  </filter>
                  <linearGradient
                    gradientUnits="userSpaceOnUse"
                    id={`paint1_linear_${primaryColor.replace("#", "")}`}
                    x1="413.5"
                    x2="413.5"
                    y1="100"
                    y2="919.949"
                  >
                    <stop stopColor={primaryColor} />
                    <stop offset="1" stopColor={primaryColor} stopOpacity="0" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div
        className="absolute flex h-[55.223rem] items-center justify-center top-[-11.688rem] translate-x-[-50%] w-[52.564rem]"
        style={{ left: "calc(30% + 7.282rem)" }}
      >
        <div className="flex-none rotate-[162.112deg] scale-y-[-100%]">
          <div className="h-[44.875rem] relative w-[40.75rem]">
            <div className="absolute bottom-[-13.928%] left-[-15.337%] right-[-15.337%] top-[-13.928%]">
              <svg
                className="block size-full"
                fill="none"
                preserveAspectRatio="none"
                viewBox="0 0 852 918"
              >
                <g filter={`url(#filter2_f_${primaryColor.replace("#", "")})`}>
                  <path
                    d={svgQuestComplete.p17d92c00}
                    fill={`url(#paint2_linear_${primaryColor.replace(
                      "#",
                      ""
                    )})`}
                    fillOpacity="0.15"
                  />
                </g>
                <defs>
                  <filter
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                    height="918"
                    id={`filter2_f_${primaryColor.replace("#", "")}`}
                    width="852"
                    x="0"
                    y="0"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      mode="normal"
                      result="shape"
                    />
                    <feGaussianBlur
                      result="effect1_foregroundBlur"
                      stdDeviation="50"
                    />
                  </filter>
                  <linearGradient
                    gradientUnits="userSpaceOnUse"
                    id={`paint2_linear_${primaryColor.replace("#", "")}`}
                    x1="413.5"
                    x2="413.5"
                    y1="100"
                    y2="919.949"
                  >
                    <stop stopColor={primaryColor} />
                    <stop offset="1" stopColor={primaryColor} stopOpacity="0" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-4 sm:px-6 lg:px-8 pb-4 sm:pb-6 lg:pb-8 relative h-full flex">
        {/* Top Navigation Bar */}
        <div className="absolute top-0 left-0 right-0 h-[5.5rem] flex items-center justify-between bg-cover bg-center bg-no-repeat px-4 sm:px-6 lg:px-8">
          
          <div className="flex items-center gap-4">
            
            <Dialog>
              <DialogTrigger asChild>
                
              </DialogTrigger>
              <DialogContent
                className="sm:max-w-2xl rounded-[2rem] px-7 py-6 border-none shadow-lg"
                style={{
                  background: `linear-gradient(151.477deg, rgb(0,0,0) 17.606%, rgba(${hexToRgb(
                    primaryColor
                  )}, 0.6) 218.68%)`,
                  border: `1px solid linear-gradient(151.477deg, rgb(0, 0, 0) 17.606%, rgba(${hexToRgb(
                    primaryColor
                  )}, 0.4) 188.68%)`,
                  boxShadow: "0px 0px 23.4px 0px rgba(0, 0, 0, 0.50)",
                }}
              >
                <h2
                  className="text-center text-3xl py-1 font-medium"
                  style={{
                    color: primaryColor,
                    textShadow: `0 0 9px rgba(${hexToRgb(primaryColor)}, 0.49)`,
                  }}
                >
                  Settings
                </h2>

                {/* Decorative Line */}
                <div className="flex items-center justify-center relative w-full">
                  <div className="w-full">
                    <div className="h-[1px] relative w-full">
                      <div
                        className="absolute inset-0"
                        style={{
                          background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                          opacity: 0.995,
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex flex-col gap-8 mt-3 mb-2 max-w-md mx-auto w-full pt-5 pb-3">
                  <div className="flex flex-col gap-10">
                    {/* Music Volume */}
                    <div className="flex flex-col gap-1 items-center">
                      <label className="text-2xl font-rubik mb-2 text-white font-normal tracking-[-0.005rem]">
                        Music Volume
                      </label>
                      <Slider
                        defaultValue={[40]}
                        max={100}
                        step={1}
                        className="w-full"
                        
                      />
                    </div>
                    {/* Voice Over Volume */}
                    <div className="flex flex-col gap-1 items-center">
                      <label className="text-2xl font-rubik mb-2 text-white font-normal tracking-[-0.005rem]">
                        Voice over volume
                      </label>
                      <Slider
                        defaultValue={[20]}
                        max={100}
                        step={1}
                        className="w-full"
                        
                      />
                    </div>
                    {/* Color Picker */}
                    <div className="flex flex-col gap-1 items-center">
                      <label className="text-2xl font-rubik mb-2 text-white font-normal tracking-[-0.005rem]">
                        Set Theme
                      </label>
                      <ColorPicker />
                    </div>
                  </div>

                  {/* Okay button */}
                  <DialogTrigger asChild>
                    <Buttons
                      variant="ghost"
                      size="sm"
                      className="w-[5.75rem] text-lg h-11 py-2 px-4 rounded-4xl transition-all duration-200 hover:scale-110 text-white hover:text-white mx-auto"
                      style={{
                        background: `linear-gradient(275.041deg
                              ,
                                rgba(${hexToRgb(
                                  primaryColor
                                )}, 0.7) 7.25%, rgba(0, 0, 0, 0.8) 84.803%)`,
                        border: `1px solid ${primaryColor}`,
                        boxShadow: `0px 0px 15.9542px 0px rgba(3, 51, 38, 0.8)`,
                      }}
                    >
                      Okay
                    </Buttons>
                  </DialogTrigger>
                </div>
              </DialogContent>
            </Dialog>
          </div>
        </div>

        {/* Quest Complete Container */}
        <div className="mt-10 flex h-full flex-grow flex-col items-center justify-center gap-6 bg-cover bg-center bg-no-repeat 2xl:gap-8">
          {/* Quest Complete Title */}
          <div
            className="hidden lg:flex flex-col justify-center leading-[normal] font-medium text-4xl text-center text-nowrap top-[10.75rem] tracking-[0.08px] uppercase whitespace-pre"
            style={{
              color: primaryColor,
            }}
          >
            <p className="adjustLetterSpacing block mb-0">Game</p>
            <p className="adjustLetterSpacing block">Complete</p>
          </div>
          <div
            className="flex lg:hidden flex-col justify-center leading-[normal] font-medium text-4xl text-center text-nowrap top-[9.75rem] tracking-[0.08px] uppercase whitespace-pre"
            style={{
              color: primaryColor,
            }}
          >
            <p className="adjustLetterSpacing block mb-0">Quest Complete</p>
          </div>

          {/* Main Quest Complete Card */}
          <div className="backdrop-blur-[12.5rem] backdrop-filter rounded-[1.71rem] w-full max-w-[60.75rem] mx-auto bg-black/20 relative px-4 sm:px-0">
            <div className="box-border content-stretch flex flex-row gap-3 items-center justify-center overflow-clip p-3 sm:p-5 relative w-full">
              <div className="flex flex-col items-center relative w-full 2xl:size-full">
                <div className="box-border content-stretch flex flex-col gap-4 sm:gap-6 2xl:gap-[1.924rem] items-center justify-start p-2 sm:p-3 relative w-full">
                  {/* Success Message */}
                  <div className="flex flex-col font-rubik font-normal justify-end max-w-[40.75rem] leading-[normal] relative shrink-0 text-[#ffffff] text-xl text-center tracking-[-0.0805px]">
                    <p className="adjustLetterSpacing block whitespace-pre-wrap ">
                      {/* {quetCompletionMessage}
                       */}
                                             Congrats! You’ve completed Project ECHO and built the clarity, confidence and capability to lead with impact.

                    </p>
                  </div>

                  {/* Rewards Section Header */}
                  <div className="box-border content-stretch flex flex-row gap-3 items-center justify-start p-0 relative shrink-0 w-full">
                    <div className="basis-0 grow h-0 min-h-px min-w-px relative shrink-0">
                      <div className="absolute bottom-0 left-0 right-0 top-[-0.895px]">
                        <svg
                          className="block size-full"
                          fill="none"
                          preserveAspectRatio="none"
                          viewBox="0 0 237 1"
                        >
                          <line
                            stroke={`url(#paint0_linear_rewards_${primaryColor.replace(
                              "#",
                              ""
                            )})`}
                            strokeWidth="0.894962"
                            x2="236.341"
                            y1="0.552519"
                            y2="0.552519"
                          />
                          <defs>
                            <linearGradient
                              gradientUnits="userSpaceOnUse"
                              id={`paint0_linear_rewards_${primaryColor.replace(
                                "#",
                                ""
                              )}`}
                              x1="236.341"
                              x2="0"
                              y1="0.999899"
                              y2="0.999903"
                            >
                              <stop stopColor={primaryColor} />
                              <stop
                                offset="0.484375"
                                stopColor={primaryColor}
                                stopOpacity="0.994792"
                              />
                              <stop
                                offset="1"
                                stopColor={primaryColor}
                                stopOpacity="0"
                              />
                            </linearGradient>
                          </defs>
                        </svg>
                      </div>
                    </div>
                    <div
                      className="flex flex-col justify-center leading-[0] not-italic relative shrink-0 text-xl text-center text-nowrap tracking-[0.08px] uppercase"
                      style={{ color: primaryColor }}
                    >
                      <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
                        Rewards
                      </p>
                    </div>
                    <div className="basis-0 flex grow items-center justify-center min-h-px min-w-px relative shrink-0">
                      <div className="flex-none rotate-[180deg] scale-y-[-100%] w-full">
                        <div className="h-0 relative w-full">
                          <div className="absolute bottom-0 left-0 right-0 top-[-0.895px]">
                            <svg
                              className="block size-full"
                              fill="none"
                              preserveAspectRatio="none"
                              viewBox="0 0 237 1"
                            >
                              <line
                                stroke={`url(#paint1_linear_rewards_${primaryColor.replace(
                                  "#",
                                  ""
                                )})`}
                                strokeWidth="0.894962"
                                x2="236.341"
                                y1="0.552519"
                                y2="0.552519"
                              />
                              <defs>
                                <linearGradient
                                  gradientUnits="userSpaceOnUse"
                                  id={`paint1_linear_rewards_${primaryColor.replace(
                                    "#",
                                    ""
                                  )}`}
                                  x1="236.341"
                                  x2="0"
                                  y1="0.999899"
                                  y2="0.999903"
                                >
                                  <stop stopColor={primaryColor} />
                                  <stop
                                    offset="0.484375"
                                    stopColor={primaryColor}
                                    stopOpacity="0.994792"
                                  />
                                  <stop
                                    offset="1"
                                    stopColor={primaryColor}
                                    stopOpacity="0"
                                  />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Rewards Cards */}
                  <div className="box-border content-stretch flex flex-row gap-5 items-center justify-start px-3 relative shrink-0 w-full">
                    {/* ✅ UPDATED: Pass allQuestScores instead of individual progress */}
                    <RewardCard
                      title="Points"
                      allQuestScores={allQuestScores}
                      icon="points"
                    />
 
                    {/* ✅ UPDATED: Use new star calculation based on overall game scores */}
                    <StarsCard
                      filledStars={starFill}
                      totalStars={3}
                      visible
                      animationDelay={600}
                      onStarIgnite={() => playClickSound()}
                    />
{/* kishore */}
 <RewardCard title='People Leader' icon="trophy" badgeImg={badgeImg}
                     />
                    {/* <RewardCard title="Empathy Pro" icon="trophy" /> */}
                  </div>


                 

                  {/* Bottom Navigation */}
                  <div className="flex w-full items-center justify-between">
                    <NavigationArrow
                      direction="left"
                      onClick={() => previousNavigation()}
                    />
                    
                    <NavigationArrow
                      direction="right"
                      onClick={() => {
                        playClickSound();

                        setCurrentScreenId(22); 
                          // setCurrentScreenId(19); 
                      
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Glowing border effects */}
            <div className="absolute contents -top-1 left-1/2 translate-x-[-50%]">
              <div className="absolute flex h-2 items-center justify-center w-[27.5rem] -top-1 left-1/2 translate-x-[-50%]">
                <div className="flex-none scale-y-[-100%]">
                  <div
                    className="blur-xs filter h-2 w-[27.5rem]"
                    style={{
                      backgroundImage: `url('data:image/svg+xml;utf8,<svg viewBox="0 0 440 7" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"><rect x="0" y="0" height="100%" width="100%" fill="url(%23grad)" opacity="1"/><defs><radialGradient id="grad" gradientUnits="userSpaceOnUse" cx="0" cy="0" r="10" gradientTransform="matrix(22 0 0 0.35 220 3.5)"><stop stop-color="rgba(${hexToRgb(
                        primaryColor
                      )},1)" offset="0"/><stop stop-color="rgba(${hexToRgb(
                        primaryColor
                      )},0)" offset="1"/></radialGradient></defs></svg>')`,
                    }}
                  />
                </div>
              </div>
              <div className="absolute flex h-0.5 items-center justify-center w-[27.5rem] -top-1 left-1/2 translate-x-[-50%]">
                <div className="flex-none scale-y-[-100%]">
                  <div
                    className="blur-xs filter h-0.5 w-[27.5rem]"
                    style={{
                      backgroundImage: `url('data:image/svg+xml;utf8,<svg viewBox="0 0 440 2" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"><rect x="0" y="0" height="100%" width="100%" fill="url(%23grad)" opacity="1"/><defs><radialGradient id="grad" gradientUnits="userSpaceOnUse" cx="0" cy="0" r="10" gradientTransform="matrix(22 0 0 0.1 220 1)"><stop stop-color="rgba(${hexToRgb(
                        primaryColor
                      )},1)" offset="0"/><stop stop-color="rgba(${hexToRgb(
                        primaryColor
                      )},0)" offset="1"/></radialGradient></defs></svg>')`,
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Inner Shadow Border */}
            <div
              className="absolute inset-0 pointer-events-none rounded-[2.375rem]"
              style={{
                boxShadow: `0px 0px 11px 0px inset rgba(${hexToRgb(
                  primaryColor
                )}, 0.3), 0px 0px 20px 0px rgba(${hexToRgb(
                  primaryColor
                )}, 0.2)`,
              }}
            />
          </div>
        </div>
      </div>

      {/* Floating particles */}
      <div
        className="absolute contents top-[4.697rem]"
        style={{ left: "calc(20% + 7.75rem)" }}
      >
        <FloatingParticles1 />
      </div>
      <div
        className="absolute contents top-[4.745rem]"
        style={{ left: "calc(20% + 4.438rem)" }}
      >
        <FloatingParticles2 />
      </div>
      <div
        className="absolute contents top-[25.75rem]"
        style={{ left: "calc(20% + 4.188rem)" }}
      >
        <FloatingParticles3 />
      </div>
    </div>
  );
};



export default OverallQuestCompletionFutureTheme;







